import { GSEndpoint } from "../models/endpoint";
import { User } from "../models/user";

export interface SaveDefaultsRequest {
    projectNames: string[];
    difficulty: string;
    TEH: boolean;
    hintType: string;
}

export interface DefaultsResponse {
    projectNames: string[];
    difficulty: string;
    TEH: boolean;
    hintType: string;
}

export class GetDefaults extends GSEndpoint<{}, DefaultsResponse> {
    constructor() {
        super("projects/defaults", "GET", []);
    }

    override async request(user: User): Promise<DefaultsResponse> {
        return await this.makeRequest({}, user);
    }
}

export class PostDefaults extends GSEndpoint<SaveDefaultsRequest> {
    constructor() {
        super("projects/defaults", "POST", []);
    }

    override async request(req: SaveDefaultsRequest, user: User): Promise<{}> {
        return await this.makeRequest(req, user);
    }
}
